@let c = content();

<div class="hr-intro" data-testid="hr-tool-info-box">
  <app-safe-html-output
    class="hr-intro__prose block"
    [html]="c.intro?.translations | translateDirectusTemplate"
  />
  <app-safe-html-output
    class="hr-intro__prose block"
    [html]="c.noticeContent?.translations | translateDirectusTemplate"
  />
</div>
